import React from 'react'
import { useTheme, alpha } from '@mui/material'

const HeaderRoundedIcon: React.FC<React.PropsWithChildren> = ({ children }) => {
  const theme = useTheme()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
      }}
    >
      <div
        style={{
          width: '110px',
          height: '110px',
          backgroundColor: alpha(theme.palette.primary.main, 0.12),
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default HeaderRoundedIcon
